import React from "react";
import { Loader } from "@mantine/core";

const LoadingCard = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0)", // Slightly transparent white
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        backdropFilter: "blur(2px)", // Add blur effect
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "24px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)", // Elegant shadow
          maxWidth: "320px",
          width: "90%",
        }}
      >
        <img src={"/logo.png"} alt="Logo" style={{ marginBottom: "16px", height: "60px" }} /> {/* Optional logo */}
        <Loader size="lg" color="blue" variant="dots" /> {/* Mantine loader */}
        <p style={{ marginTop: "16px", fontSize: "16px", color: "#555" }}>
          Processing your request...
        </p>
      </div>
    </div>
  );
};

export default LoadingCard;
